import React from 'react';

import { LocaleString } from '@biw/intl';

import './progress-header-message.scss';

interface Props {
    header: string;
    subheader: string;
    text: string;
}

const defaultProps = {
    header: 'progress.oops',
    subheader: 'progress.noSelection',
    text: 'progress.noSelectionSubText',
};
const ProgressHeaderMessage = ({
    header,
    subheader,
    text,
}: Props) => (
    <div className="progress-header-message" data-sel="progress-no-goal-selected-header">
        <h2>
            <LocaleString className="branding-primary-text" code={header}/>
        </h2>
        <h3>
            <LocaleString className="branding-primary-text" code={subheader}/>
        </h3>
        <p>
            <LocaleString code={text}/>
        </p>
    </div>
);

ProgressHeaderMessage.defaultProps = defaultProps;
export default ProgressHeaderMessage;
